let transitioning = false;

const foreach = (selector, callback) => {
    const elements = document.querySelectorAll(selector);
    [].forEach.call(elements, callback);
}

function handleClickBlock(e) {
    e.preventDefault();

    transitioning = true;
    let element = e.target;
    while(!element.classList.contains('intro-block')) {
        element = element.parentNode;
    }
    const clone = element.cloneNode(true);
    const rect = element.getBoundingClientRect();
    const newStyle = {
        top: rect.y + 'px', 
        left: rect.x + 'px',
    }
    Object.assign(clone.style, newStyle);
    clone.classList.add('clone');
    document.body.appendChild(clone);
    clone.offsetHeight;
    clone.ontransitionend = () => {
        console.log('ended!');
        clone.ontransitionend = () => {};
    }
    clone.classList.add('wide');
    Object.assign(clone.style, {
            left: '',
        });
    setTimeout(() => {
        clone.offsetHeight;
        clone.classList.add('headerPosition');
        document.querySelector('header').classList.add('light-content');
        Object.assign(clone.style, {
            top: '',
        });
        setTimeout(() => {
            location.href = element.getAttribute('href')
            transitioning = false;
        }, 500);
    }, 500);

    element.parentNode.classList.add('hide');
    setTimeout(() => {
        element.parentNode.remove();
    }, 500);
}

function setupClickHandlers() {
    foreach('.intro-block', (element) => {
        element.addEventListener('click', handleClickBlock);
    });
}

function init() {
    setupClickHandlers();
}

export default {
    init,
}



// WEBPACK FOOTER //
// ./assets/js/introBlocks.js